import { Box, Footer } from '@eluve/components';
import {
  useAppointmentId,
  useTenantId,
} from '@eluve/frontend-appointment-hooks';
import { FeatureFlaggedComponent } from '@eluve/smart-blocks';

import { TranscriptionConfidenceAlert } from '../../TranscriptionConfidenceAlert';
import { TranscriptionWaveform } from '../machines/transcription/components/TranscriptionWaveform';

import { AppointmentTranscriptionPageControls } from './AppointmentTranscriptionPageControls';

export const AppointmentTranscriptionFooter: React.FC = () => {
  const appointmentId = useAppointmentId();
  const tenantId = useTenantId();

  return (
    <Footer>
      <Box
        spaceBetween
        className="relative mx-auto w-full max-w-screen-lg flex-wrap items-center gap-2"
      >
        <TranscriptionWaveform />

        <FeatureFlaggedComponent flag="ENABLE_TRANSCRIPTION_LOW_CONFIDENCE_DIALOGUE">
          <TranscriptionConfidenceAlert />
        </FeatureFlaggedComponent>

        <AppointmentTranscriptionPageControls
          tenantId={tenantId}
          appointmentId={appointmentId}
        />
      </Box>
    </Footer>
  );
};
